import * as actions from './constants';

export function showSpinnerLoading(visible, message) {
    return {
        type: actions.TOGGLE_LOADING,
        visible,
        message
    }
}
